import { useQuery } from '@tanstack/react-query';
import { getPageInsightsApiV3InsightsPagePost, GetPageInsightsApiV3InsightsPagePostData } from '../config/api';
import { extractAxiosResponse } from '../config/axios.config';
import { useFilters } from '../contexts/FiltersContext';

type PageName = GetPageInsightsApiV3InsightsPagePostData['path']['page'];

export function usePageInsights(page: PageName, brandIds?: number[]) {
  const { selectedBrand, loading: filtersLoading, getFiltersByType } = useFilters();

  const effectiveBrandIds = brandIds ?? (selectedBrand ? [selectedBrand] : []);

  const { data, isPending, error } = useQuery({
    queryKey: ['v3', 'page-insights', page, effectiveBrandIds, getFiltersByType('traditional')],
    queryFn: () =>
      extractAxiosResponse(
        getPageInsightsApiV3InsightsPagePost({
          path: { page },
          body: {
            brand_ids: effectiveBrandIds,
            filters: getFiltersByType('traditional'),
          },
        })
      ),
    enabled: !filtersLoading && effectiveBrandIds.length > 0,
  });

  const insights = data?.insights
    ?.split('\n')
    .map((line: string) => line.replace(/^[-*•]\s*/, '').trim())
    .filter((line: string) => line.length > 0) ?? null;

  return { insights, loading: isPending, error };
}
